// extracted by mini-css-extract-plugin
export default {"this_header":"info_this_header__0DgCR","content_item":"info_content_item__FBayR","btn_list":"info_btn_list__2VaBB"};